const middleware = {}

middleware['recaptcha'] = require('../middleware/recaptcha.js')
middleware['recaptcha'] = middleware['recaptcha'].default || middleware['recaptcha']

export default middleware
